import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MaintenanceSliceState {
    startDate: Nilable<string>;
    endDate: Nilable<string>;
}

export const initialState: MaintenanceSliceState = {
    startDate: null,
    endDate: null,
};

export const maintenanceSlice = createSlice({
    name: 'maintenance',
    initialState,
    reducers: (create) => ({
        setMaintenanceSettings: create.reducer((state, { payload }: PayloadAction<MaintenanceSliceState>) => {
            state.startDate = payload.startDate;
            state.endDate = payload.endDate;
        }),
        clearMaintenanceSettings: create.reducer((state) => {
            Object.keys(state).forEach((key) => {
                state[key] = initialState[key];
            });
        }),
    }),
    selectors: {
        selectMaintenance: (maintenance) => maintenance,
    },
});

export const { setMaintenanceSettings, clearMaintenanceSettings } = maintenanceSlice.actions;
export const { selectMaintenance } = maintenanceSlice.selectors;
